import React, { forwardRef } from 'react';
import SearchPairedWithText from '../text-pairing/Search';
const Search = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 24 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("path", { d: "m24 22.95-7.5-7.5a9.199 9.199 0 0 0 2.25-6.075C18.75 4.2 14.55 0 9.375 0S0 4.2 0 9.375s4.2 9.375 9.375 9.375a9.199 9.199 0 0 0 6.075-2.25l7.5 7.5zM1.5 9.375C1.5 5.025 5.025 1.5 9.375 1.5s7.875 3.525 7.875 7.875-3.525 7.875-7.875 7.875S1.5 13.725 1.5 9.375z", fill: "currentColor" }))));
Search.displayName = 'Search';
// @ts-ignore;
const iconData = {
    glyph: Search,
    group: 'basic',
    textPairingGlyph: SearchPairedWithText,
};
export default iconData;
